import React from "react";
import "./InfoBtnsSection.css";
import logoB1 from "./b1.svg";
import logoB2 from "./b2.svg";
import logoB3 from "./b3.svg";
import logoB4 from "./b4.svg";

import SaberMasButton from "../../../components/SaberMasBtn/SaberMasBtn";
import "../../../components/SaberMasBtn/SaberMasBtn.css";

const InfoBtnsSection = () => {
  return (
    <section className="white-section">
      <div className="rectangular-container">
        <div className="rectangular-btn-container">
          <div className="rectangular-btn">
            <img src={logoB1} alt="Logo 1" className="large-logo" />
            <h3>Nosotros</h3>
            <span>Somos una empresa fundada en Madrid, España en 1988.</span>
            <SaberMasButton variant="card" to="/trajectorysection" context="card-nosotros" />
          </div>

          <div className="vertical-divider"></div>

          <div className="rectangular-btn">
            <img src={logoB2} alt="Logo 2" className="large-logo" />
            <h3>Misión: Calidad</h3>
            <span>Triple certificación en Gestión de calidad, Gestión ambiental y Gestión de seguridad/salud.</span>
            <SaberMasButton
              variant="card"
              to="/cngroup/1"
              context="card-calidad"
            />
          </div>

          <div className="vertical-divider"></div>

          <div className="rectangular-btn">
            <img src={logoB3} alt="Logo 3" className="large-logo" />
            <h3>Valores: Ética</h3>
            <span>Somos una empresa transparente respaldada por el apoyo de clientes y accionistas.</span>
            <SaberMasButton
              variant="card"
              to="/cngroup/3"
              context="card-etica"
            />
          </div>

          <div className="vertical-divider"></div>

          <div className="rectangular-btn">
            <img src={logoB4} alt="Logo 4" className="large-logo" />
            <h3>Equipo</h3>
            <span>Combinamos experiencia y técnicas de vanguardia</span>
            <SaberMasButton
              variant="card"
              to="/cngroup/0"
              context="card-equipo"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoBtnsSection;